import { Component, OnInit } from '@angular/core';
import { LanguageService } from '@uigy/shared/services/language.service';
import { LicenseDialogsService } from '@uigy/modules/license/license-dialogs.service';
import { LicenseManagerService } from '@uigy/modules/license/license-manager.service';
import { first, take } from 'rxjs/operators';
import { ActivationCodeSource, LicenseStatus } from '@uigy/generated/graphql';
import { FeatureFlagService } from '@uigy/shared/services/feature-flag.service';

@Component({
    selector: 'app-license-activation',
    templateUrl: './license-activation.component.html',
    styleUrls: ['./license-activation.component.scss'],
    standalone: false
})
export class LicenseActivationComponent implements OnInit {
  public activeStep = 1;
  public pageTexts = this.languageService.texts.license_activation;

  constructor(
    private languageService: LanguageService,
    private licenseManagerService: LicenseManagerService,
    private licenseDialogsService: LicenseDialogsService,
    private featureFlagService: FeatureFlagService
  ) { }

  ngOnInit(): void {
    this.licenseManagerService.getLicenseStatus().pipe(take(1)).subscribe(status => {
      if (status === LicenseStatus.WaitingForActivation) {
        this.activeStep = 3;
      }
    });
  }

  public openLicenseCodeDialog(): void {
    this.licenseDialogsService.openLicenseCodeDialog().pipe(first()).subscribe(() => this.activeStep = 2);
  }

  public openLicenseCodePopup(): void {
    if (this.activeStep > 2) {
      this.licenseDialogsService.openLicenseCodePopup().pipe(first()).subscribe(() => this.activeStep = 2);
    } else {
      this.openLicenseCodeDialog();
    }
  }

  public openCertificateDialog(): void {
    this.licenseDialogsService.openCertificateDialog(ActivationCodeSource.FromPending).pipe(first()).subscribe(() => this.activeStep = 3);
  }

  public openActivationCodeDialog(): void {
    this.licenseDialogsService.openActivationCodeDialog().pipe(first()).subscribe(()=> {
      this.featureFlagService.init();
    });
  }
}
